const options = {
  5: "bg-green-400/5",
  10: "bg-green-400/10",
  25: "bg-green-400/25",
  50: "bg-green-400/50",
  75: "bg-green-400/75",
  90: "bg-green-400/90",
  100: "bg-green-400",
};

const from = {
  5: "from-green-400/5",
  10: "from-green-400/10",
  25: "from-green-400/25",
  50: "from-green-400/50",
  75: "from-green-400/75",
  90: "from-green-400/90",
  100: "from-green-400",
};

export default function getBackgroundGreen400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
